
import { SvgIcon, SvgIconProps } from "@mui/material";
    
export const ClockFilledIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
   <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M12 19.503a7.503 7.503 0 1 0 0-15.006 7.503 7.503 0 0 0 0 15.006Zm.5-12.505a.5.5 0 0 0-1 0V12a.5.5 0 0 0 .342.474l2.88.96a.5.5 0 0 0 .316-.949L12.5 11.64V6.998Z" clip-rule="evenodd"/></svg>
  </SvgIcon>
);
